import { useMutation as e } from "@maat/store-hooks";
import { authApi as t } from "@maat/api-main";
//#region src/password/useForgotPasswordVerifyMutation.ts
var n = () => e({
	mutationFn: t.forgotPasswordVerify,
	retry: !1
});
//#endregion
export { n as useForgotPasswordVerifyMutation };
